import React, { useState, useEffect } from "react";
import {
    Form,
    Input,
    FormInstance,
    Cascader,
    TreeSelect,
    Spin,
    Space,
    Button,
    Row,
    Col,
    Upload,
    notification, Select, Table, Radio, Tooltip, Tag,
    InputNumber
} from "antd";
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { 
    deleteMacTemplateLoginWindow, addMacTemplateLoginWindow, getMacTemplateLoginWindow
} from "../../../axios/api.device"
import { UploadChangeParam } from "antd/lib/upload";
import { UploadFile } from "antd/lib/upload/interface";

import { useTranslation } from "react-i18next";
import i18n from "@src/locales";
import { debug } from "console";

const { Column } = Table;
const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateConentLoginWindow = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [dataForm] = Form.useForm();
    const [showFullName, setShowFullName] = useState<boolean>(true);
    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2)

    }
    useEffect(() => {
        getDataInfo();
    }, [])

    const getDataInfo = () => {
        getMacTemplateLoginWindow(templateId).then((res) => {
            if (res && res != null) {
                setShowTable(2)
                var data: any = {};
                setShowFullName(res.showFullName);
                data.loginWindowText = res.loginwindowText;
                data.adminHostInfo = res.adminHostInfo;
                data.showFullName = res.showFullName;
                if(!res.showFullName)
                {
                    data.hideLocalUsers = res.accountSettingItem?.hideLocalUsers;
                    data.hideMobileAccounts = res.accountSettingItem?.hideMobileAccounts;
                    data.includeNetworkUser = res.accountSettingItem?.includeNetworkUser;
                    data.hideAdminUsers = res.accountSettingItem?.hideAdminUsers;
                    data.showOtherUsers = res.accountSettingItem?.showOtherUsers;
                }
                data.shutDownDisabled = res.shutDownDisabled;
                data.sleepDisabled = res.sleepDisabled;
                data.restartDisabled = res.restartDisabled;
                data.disableFDEAutoLogin = res.disableFDEAutoLogin;
                data.logOutDisabledWhileLoggedIn = res.logOutDisabledWhileLoggedIn;
                data.disableConsoleAccess = res.disableConsoleAccess;
                console.log('data',data);
                dataForm?.setFieldsValue(data);
            } else {
                setShowTable(1)
            }
        })
    }
    const addTemplateClick = () => {
        dataForm?.validateFields().then(
            (res) => {
                var req: any = {};
                req.loginWindowText = res.loginWindowText;
                req.adminHostInfo = res.adminHostInfo;
                req.showFullName = res.showFullName;
                if(!req.showFullName)
                {
                    req.accountSettingItem = {
                        hideLocalUsers : res.hideLocalUsers,
                        hideMobileAccounts : res.hideMobileAccounts,
                        includeNetworkUser : res.includeNetworkUser,
                        hideAdminUsers : res.hideAdminUsers,
                        showOtherUsers : res.showOtherUsers
                    };
                }
                req.shutDownDisabled = res.shutDownDisabled;
                req.sleepDisabled = res.sleepDisabled;
                req.restartDisabled = res.restartDisabled;
                req.disableFDEAutoLogin = res.disableFDEAutoLogin;
                req.logOutDisabledWhileLoggedIn = res.logOutDisabledWhileLoggedIn;
                req.disableConsoleAccess = res.disableConsoleAccess;
                console.log(req);
                
                addMacTemplateLoginWindow(templateId, req).then(() => {
                    updateTemplate();
                    notification.success({ message: t("成功") });
                    dataForm.resetFields();
                    getDataInfo();
                })
            })
    }
    const deleteTemplateClick = () => {
        deleteMacTemplateLoginWindow(templateId).then(() => {
            updateTemplate();
            notification.success({ message: t("成功") });
            dataForm?.resetFields();
            getDataInfo();
        })
    }

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle">{t("登录界面")}</Col>
                {platform != "Android" && (
                    <Col style={{ marginLeft: 36 }}>
                        {templateTab?.availabilities?.map((c: any) => (
                            <Tooltip title={
                                i18n.language === "zh" ? `只能在${c}以上的设备上才能配置` : 
                                i18n.language === "en" ? `Only be configured on devices above iOS ${c}` : ""
                            }>
                                <Tag color="cyan">{c}</Tag>
                            </Tooltip >
                        ))}
                        {templateTab?.supervisedRequired && (
                            <Tooltip title={t("只适用于受监督设备")}>
                                <Tag color="purple">S</Tag>
                            </Tooltip>
                        )}
                    </Col>
                )}
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    <div>
                        {/* <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("安全")}</p> */}
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <>
                        <Form
                            style={{ width: "90%", marginTop: 36 }}
                            layout="horizontal"
                            form={dataForm}
                            labelCol={{ span: 4 }}
                            initialValues={{loginWindowText: "",adminHostInfo:"",showFullName:true,
                                hideLocalUsers:false,hideMobileAccounts:false,includeNetworkUser:true,
                                hideAdminUsers: false, showOtherUsers:true,shutDownDisabled:false, sleepDisabled:false,
                                restartDisabled: false, disableFDEAutoLogin:false,disableConsoleAccess:false,
                                logOutDisabledWhileLoggedIn: false
                              }}
                        >
                            <Item 
                                label={t("登录界面文案")} 
                                name="loginWindowText"
                                extra={"此文案将在登录界面下方显示"}
                            >
                                <Input  style={{width:"50%"}}></Input>
                            </Item>
                            <Item label={t("主机信息")} name="adminHostInfo">
                                <Select style={{width:"50%"}}>
                                    <Select.Option value={""}>{t("不显示")}</Select.Option>
                                    <Select.Option value={"HostName"}>{t("显示")}</Select.Option>
                                </Select>
                            </Item>
                            <Item label={t("名称和密码")} name="showFullName">
                                <Select style={{width:"50%"}} onChange={(key: boolean) => {
                                    setShowFullName(key);
                                }}>
                                    <Select.Option value={false}>{t("用户列表")}</Select.Option>
                                    <Select.Option value={true}>{t("输入框")}</Select.Option>
                                </Select>
                            </Item>
                            {!showFullName && <>
                                <Item 
                                    label={t("本地账户")} 
                                    name="hideLocalUsers"
                                    style={{paddingLeft:"100px"}}
                                >
                                    <Select style={{width:"50%"}}>
                                        <Select.Option value={false}>{t("显示")}</Select.Option>
                                        <Select.Option value={true}>{t("隐藏")}</Select.Option>
                                    </Select>
                                </Item>
                                <Item 
                                    label={t("移动账户")} 
                                    name="hideMobileAccounts"
                                    style={{paddingLeft:"100px"}}
                                >
                                    <Select style={{width:"50%"}}>
                                        <Select.Option value={false}>{t("显示")}</Select.Option>
                                        <Select.Option value={true}>{t("隐藏")}</Select.Option>
                                    </Select>
                                </Item>
                                <Item 
                                    label={t("网络账户")} 
                                    name="includeNetworkUser"
                                    style={{paddingLeft:"100px"}}
                                >
                                    <Select style={{width:"50%"}}>
                                        <Select.Option value={false}>{t("隐藏")}</Select.Option>
                                        <Select.Option value={true}>{t("显示")}</Select.Option>
                                    </Select>
                                </Item>
                                <Item 
                                    label={t("管理员账户")} 
                                    name="hideAdminUsers"
                                    style={{paddingLeft:"100px"}}
                                >
                                    <Select style={{width:"50%"}}>
                                        <Select.Option value={false}>{t("显示")}</Select.Option>
                                        <Select.Option value={true}>{t("隐藏")}</Select.Option>
                                    </Select>
                                </Item>
                                <Item 
                                    label={t("其他")} 
                                    name="showOtherUsers"
                                    style={{paddingLeft:"100px"}}
                                >
                                    <Select style={{width:"50%"}}>
                                        <Select.Option value={false}>{t("隐藏")}</Select.Option>
                                        <Select.Option value={true}>{t("显示")}</Select.Option>
                                    </Select>
                                </Item>
                            </>}
                            <Item name="shutDownDisabled" label={t("关机按钮")}>
                                <Select style={{width:"50%"}}>
                                    <Select.Option value={false}>{t("显示")}</Select.Option>
                                    <Select.Option value={true}>{t("隐藏")}</Select.Option>
                                </Select>
                            </Item>
                            <Item name="sleepDisabled" label={t("休眠按钮")}>
                                <Select style={{width:"50%"}}>
                                    <Select.Option value={false}>{t("显示")}</Select.Option>
                                    <Select.Option value={true}>{t("隐藏")}</Select.Option>
                                </Select>
                            </Item>
                            <Item name="restartDisabled" label={t("重启按钮")}>
                                <Select style={{width:"50%"}}>
                                    <Select.Option value={false}>{t("显示")}</Select.Option>
                                    <Select.Option value={true}>{t("隐藏")}</Select.Option>
                                </Select>
                            </Item>
                            <Item name="disableFDEAutoLogin" label={t("自动登录")}>
                                <Select style={{width:"50%"}}>
                                    <Select.Option value={false}>{t("允许")}</Select.Option>
                                    <Select.Option value={true}>{t("禁止")}</Select.Option>
                                </Select>
                            </Item>
                            <Item name="logOutDisabledWhileLoggedIn" label={t("登出")}>
                                <Select style={{width:"50%"}}>
                                    <Select.Option value={false}>{t("允许")}</Select.Option>
                                    <Select.Option value={true}>{t("禁止")}</Select.Option>
                                </Select>
                            </Item>
                            <Item name="disableConsoleAccess" label={t("控制台访问")}>
                                <Select style={{width:"50%"}}>
                                    <Select.Option value={false}>{t("允许")}</Select.Option>
                                    <Select.Option value={true}>{t("禁止")}</Select.Option>
                                </Select>
                            </Item>
                        </Form>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "60%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); }}>{t("删除规则")}</Button>
                        </div>
                    </>
                )}
            </Row>
        </div>

    </>)
};